export default {
  methods: {
    onFinished() {
      this.finished = true;
      this.$emit("finished");
    },
    onAlreadyFinished() {
      this.finished = true;
      this.$emit("already-finished");
    },
  },
};
